import type { OpsTask, OpsTaskOrigin } from '../types';

export function opsOriginLabel(origin?: OpsTaskOrigin): string | null {
  if (!origin) return null;
  // Prefer an explicit short badge (e.g. "From meeting") over meeting title text.
  if (origin.label?.trim()) return origin.label.trim();
  switch (origin.kind) {
    case 'meeting':
      return 'From meeting';
    case 'email':
      return 'From email';
    case 'agent':
      return origin.agentName ? `From ${origin.agentName}` : 'From agent';
    case 'manual':
      return 'Manual';
    default:
      return null;
  }
}

/** Deep link when origin carries enough context. */
export function opsOriginHref(task: OpsTask): string | null {
  const o = task.origin;
  if (!o) return null;
  if (o.kind === 'email' && o.emailThreadId) {
    return `/executive?thread=${encodeURIComponent(o.emailThreadId)}`;
  }
  const meetingNoteId = o.meetingId || task.sourceMeetingNoteId;
  if (o.kind === 'meeting' && task.projectId && meetingNoteId) {
    const q = new URLSearchParams();
    q.set('tab', 'comments');
    q.set('meetingNote', meetingNoteId);
    return `/project-hub/${task.projectId}?${q.toString()}`;
  }
  if (o.kind === 'meeting' && task.projectId) {
    const q = new URLSearchParams();
    q.set('tab', 'comments');
    return `/project-hub/${task.projectId}?${q.toString()}`;
  }
  return null;
}

/** Tasks created via the ops agent API (not manual UI creates). */
export function isAgentCreatedOpsTask(task: OpsTask): boolean {
  const createdBy = String(task.createdBy ?? '').trim();
  if (createdBy.toLowerCase().startsWith('agent:')) return true;

  const kind = task.origin?.kind;
  return kind === 'meeting' || kind === 'email' || kind === 'agent';
}
